import { connect } from 'react-redux'

//state
import { stopAction, setModalContentAction } from '../../State/actions'


const FormHeader = (props) => {

    let title = props.currentChapterTitle;

    const onStop = () => {
        props.stop(true)
        props.setModalContent('CLOSE')
    }

    return (
        <>
            <nav className="pension-wizard-block__form-header">
                <div className="pension-wizard-block__form-header__container">
                    <a className="pension-wizard-block__form-header__container__logo"
                        href="/"
                        aria-label="Tillbaka till startsidan"
                    >
                        <img
                            src="../../../images/heart-small.svg"
                            alt=''
                        />
                    </a>
                    <p className="pension-wizard-block__form-header__container__title">{title}</p>
                    <button
                        className="pension-wizard-block__form-header__container__close"
                        onClick={onStop}
                    >
                    </button>
                </div>
            </nav>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        currentChapterTitle: state.pensionWizardView.currentChapterTitle
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        stop: (payload) => dispatch(stopAction(payload)),
        setModalContent: (payload) => dispatch(setModalContentAction(payload))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormHeader);

